export default "__VITE_ASSET__CybERoCR__"